import { render, staticRenderFns } from "./index_four.vue?vue&type=template&id=27b8d73c&scoped=true&"
import script from "./index_four.vue?vue&type=script&lang=js&"
export * from "./index_four.vue?vue&type=script&lang=js&"
import style0 from "./index_four.vue?vue&type=style&index=0&id=27b8d73c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8d73c",
  null
  
)

export default component.exports